module.exports = __webpack_public_path__ + "img/General-freight.78b9436.jpg";